<template>
  <div
    ref="indicator"
    class="loading-more-indicator d-flex justify-center align-center pt-6 pb-4 grey--text"
    :class="{ 'has-next-page': hasNextPage, loading }"
    @click="onClick"
  >
    <v-progress-circular
      v-if="loading"
      class="mr-3"
      indeterminate
      size="20"
      width="2"
    />
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'LoadingMoreIndicator',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    hasNextPage: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['load-more'],
  data: () => ({
    observer: null,
  }),
  computed: {
    text() {
      if (this.loading) {
        return 'Loading more...';
      }
      if (!this.hasNextPage) {
        return 'No more to load';
      }
      return 'Scroll down or click here to load more';
    },
  },
  mounted() {
    // Use Intersection Observer for reliable detection when element becomes visible
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Trigger load more when indicator is visible and has next page
          if (
            entry.isIntersecting &&
            this.hasNextPage &&
            !this.loading
          ) {
            this.$emit('load-more');
          }
        });
      },
      {
        root: null, // viewport
        rootMargin: '100px', // Trigger 100px before it becomes visible
        threshold: 0.1,
      }
    );

    this.observer.observe(this.$refs.indicator);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    onClick() {
      if (!this.loading && this.hasNextPage) {
        this.$emit('load-more');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-more-indicator.has-next-page:not(.loading) {
  cursor: pointer;
}
</style>
